/** @link https://github.com/Mediabrands-MBW-Halogen-3/h3-planning/blob/bb0aa5ae6846335d1a6097e1a1436816cd8e7522/src/main/java/com/logicea/h3planning/domain/FinancialFields.java#L16 **/
export const FINANCIAL_FIELDS_SEMANTIC_CODES = [
  "grossCost",
  "mediaCommissions",
  "mediaCommission",
  "netCost",
  "mediaFees",
  "mediaFeeList",
  "agencyFees",
  "agencyFeeList",
  "agencyCommissions",
  "agencyCommission",
  "mediaTaxes",
  "mediaTax",
  "agencyTaxes",
  "agencyTax",
  "billable",
  "baseRate",
]
